var _rect, _mask, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpBoard = function SvgHelpBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 14,
    rx: 1,
    stroke: "#7D80DA",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "help-board_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 7,
    height: 6,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 7,
    height: 6,
    rx: 1,
    stroke: "#7D80DA",
    strokeWidth: 4,
    mask: "url(#help-board_svg__a)"
  })));
};
export { SvgHelpBoard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIyMyIgaGVpZ2h0PSIxNCIgcng9IjEiIHN0cm9rZT0iIzdEODBEQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8bWFzayBpZD0iZzAzM3JqankxYSIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHJlY3QgeD0iMTQiIHk9IjQiIHdpZHRoPSI3IiBoZWlnaHQ9IjYiIHJ4PSIxIi8+CiAgICA8L21hc2s+CiAgICA8cmVjdCB4PSIxNCIgeT0iNCIgd2lkdGg9IjciIGhlaWdodD0iNiIgcng9IjEiIHN0cm9rZT0iIzdEODBEQSIgc3Ryb2tlLXdpZHRoPSI0IiBtYXNrPSJ1cmwoI2cwMzNyamp5MWEpIi8+Cjwvc3ZnPgo=";